import { supabase } from '../lib/supabase';

/**
 * Genera un código de verificación de 6 dígitos
 */
function generateVerificationCode() {
  return Math.floor(100000 + Math.random() * 900000)?.toString();
}

/**
 * Servicio de email con sistema de fallback robusto
 */
class EmailService {
  /**
   * Envía código de verificación por email
   * Sistema con fallback automático a consola para desarrollo
   */
  async sendVerificationEmail(email, code = null) {
    // Generar código si no se proporciona
    const verificationCode = code || generateVerificationCode();
    
    console.log('\n' + '='?.repeat(60));
    console.log('📧 CÓDIGO DE VERIFICACIÓN GENERADO');
    console.log('='?.repeat(60));
    console.log(`✉️  Email: ${email}`);
    console.log(`🔢 CÓDIGO: ${verificationCode}`);
    console.log(`⏰ Válido por: 10 minutos`);
    console.log('='?.repeat(60) + '\n');
    
    // Guardar en localStorage para validación
    const verificationData = {
      email,
      code: verificationCode,
      timestamp: Date.now(),
      expiresAt: Date.now() + (10 * 60 * 1000) // 10 minutos
    };
    
    try {
      localStorage.setItem('verification_code', JSON.stringify(verificationData));
      console.log('✅ Código guardado en localStorage para validación');
    } catch (error) {
      console.warn('⚠️ No se pudo guardar en localStorage:', error);
    }
    
    // Intentar enviar por Edge Function (opcional, no bloqueante)
    try {
      const { data, error } = await supabase?.functions?.invoke('send-verification-email', {
        body: { email, code: verificationCode }
      });
      
      if (!error) {
        console.log('✅ Email enviado exitosamente por Edge Function');
      }
    } catch (error) {
      console.log('ℹ️ Edge Function no disponible, usando modo local');
    }
    
    return {
      success: true,
      code: verificationCode,
      message: 'Código generado exitosamente. Revisa la consola del navegador.'
    };
  }

  /**
   * Valida el código de verificación ingresado
   */
  async verifyCode(email, inputCode) {
    try {
      const storedData = localStorage.getItem('verification_code');
      
      if (!storedData) {
        console.error('❌ No hay código de verificación almacenado');
        return {
          success: false,
          message: 'No se encontró código de verificación. Solicita uno nuevo.'
        };
      }
      
      const { email: storedEmail, code: storedCode, expiresAt } = JSON.parse(storedData);
      
      // Verificar expiración
      if (Date.now() > expiresAt) {
        console.error('❌ Código expirado');
        localStorage.removeItem('verification_code');
        return {
          success: false,
          message: 'El código ha expirado. Solicita uno nuevo.'
        };
      }
      
      // Verificar email
      if (storedEmail !== email) {
        console.error('❌ Email no coincide');
        return {
          success: false,
          message: 'El código no corresponde a este email.'
        };
      }
      
      // Verificar código
      if (storedCode !== inputCode) {
        console.error('❌ Código incorrecto');
        return {
          success: false,
          message: 'Código incorrecto. Verifica e intenta nuevamente.'
        };
      }
      
      // Código válido
      console.log('✅ Código verificado exitosamente');
      localStorage.removeItem('verification_code');
      
      return {
        success: true,
        message: 'Código verificado correctamente'
      };
      
    } catch (error) {
      console.error('❌ Error al verificar código:', error);
      return {
        success: false,
        message: 'Error al verificar el código. Intenta nuevamente.'
      };
    }
  }

  /**
   * Reenvía el código de verificación
   */
  async resendVerificationCode(email) {
    console.log('🔄 Reenviando código de verificación...');
    return this.sendVerificationEmail(email);
  }

  /**
   * Obtiene el tiempo restante de validez del código en segundos
   */
  getRemainingTime(email) {
    try {
      const storedData = localStorage.getItem('verification_code');
      
      if (!storedData) {
        return 0;
      }
      
      const { email: storedEmail, expiresAt } = JSON.parse(storedData);
      
      // Verificar que el email coincida
      if (storedEmail !== email) {
        return 0;
      }
      
      const remainingMs = expiresAt - Date.now();
      
      if (remainingMs <= 0) {
        localStorage.removeItem('verification_code');
        return 0;
      }
      
      return Math.floor(remainingMs / 1000); // Retornar segundos
    } catch (error) {
      console.error('Error al obtener tiempo restante:', error);
      return 0;
    }
  }
}

export default new EmailService();